import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/registrars/profile/loading';

export const Route = createFileRoute('/_private/settings/registrars/_template/$id/')({
  staticData: {
    pageTitle: 'Registrar',
    tabKey: 'settings/registrar/profile',
  },
  pendingComponent: Loading,
});
